"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var __1 = require("../..");
var RemoteVideo_1 = __importDefault(require("./RemoteVideo"));
var Popout_1 = __importDefault(require("../Popout/Popout"));
var PresentationPopoutButton_1 = __importDefault(require("./PresentationPopoutButton"));
var useLayouts_1 = __importDefault(require("./hooks/useLayouts"));
var constants_1 = require("./constants");
// Note: the styles in this layout assume that their container is 'display: flex;'
//@ts-ignore
var useStyles = core_1.makeStyles(function () { return ({
    pip: {
        // pip is only to appear in very narrow layouts where it cannot fit in the footer
        height: constants_1.videoSmallHeight,
        left: constants_1.margin,
        position: 'absolute',
        top: 0,
        width: constants_1.videoSmallHeight * constants_1.aspectRatio_16to9
    },
    container: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column'
    },
    popoutButton: {
        bottom: constants_1.margin,
        fontSize: '12px !important',
        left: constants_1.margin,
        position: 'absolute !important',
        zIndex: 1000
    }
}); });
var MINIMIZED_VIDEO_HEIGHT = 109;
function CallLayout(props) {
    var _a, _b, _c;
    var _d = props.muteRemotes, muteRemotes = _d === void 0 ? false : _d, _e = props.presentationName, presentationName = _e === void 0 ? 'Presentation' : _e, _f = props.showMetadata, showMetadata = _f === void 0 ? true : _f, isMinimized = props.isMinimized, Slider = props.Slider, videoLayout = props.videoLayout, miniPlayerMode = props.miniPlayerMode;
    var _g = react_1.useState(false), isHovering = _g[0], setIsHovering = _g[1];
    var remoteStreams = __1.hooks.useRemoteStreamsWithId();
    var remoteStreamMetadata = __1.hooks.useRemoteStreamMetadata();
    var _h = __1.hooks.useMedia(), presentationLayout = _h.presentationLayout, layout = _h.layout, remotePresentationStream = _h.remotePresentationStream, dominantTalker = _h.dominantTalker;
    var canPin = false;
    var numberOfRemoteStreams = remoteStreams.length;
    var presentationInLayout = !!remotePresentationStream && (remotePresentationStream === null || remotePresentationStream === void 0 ? void 0 : remotePresentationStream.active) &&
        presentationLayout !== __1.constants.SFU_PRES_LAYOUT_POPPEDOUT;
    var presentationIsPopped = !!remotePresentationStream && presentationLayout === __1.constants.SFU_PRES_LAYOUT_POPPEDOUT;
    var isSliderVisible = presentationInLayout && !presentationIsPopped && Slider && !isMinimized;
    var width = isSliderVisible || miniPlayerMode ? videoLayout.videoPrimary.width : (_a = videoLayout.container) === null || _a === void 0 ? void 0 : _a.width;
    var height = (_b = videoLayout.container) === null || _b === void 0 ? void 0 : _b.height;
    var styles = useLayouts_1.default({
        layout: layout,
        numberOfRemoteStreams: numberOfRemoteStreams,
        width: width,
        height: height
    }).styles;
    var classes = useStyles();
    var remotePresentation = function () {
        var _a, _b;
        return (react_1.default.createElement(RemoteVideo_1.default, { containerStyle: __assign(__assign({}, (isMinimized && { height: MINIMIZED_VIDEO_HEIGHT, top: 0 })), (isSliderVisible && { display: 'flex', position: 'relative', width: videoLayout === null || videoLayout === void 0 ? void 0 : videoLayout.videoSecondary.container, top: 0, left: 0 })), dataTestId: 'remote-presentation-video', key: "remotePresentation", metadata: { displayName: presentationName }, muted: muteRemotes, showMetadata: false, stream: remotePresentationStream, streamId: "remotePresentation-id", videoStyle: __assign(__assign({ objectFit: 'contain' }, (isMinimized && { height: MINIMIZED_VIDEO_HEIGHT })), (isSliderVisible && { width: (_a = videoLayout === null || videoLayout === void 0 ? void 0 : videoLayout.videoSecondary) === null || _a === void 0 ? void 0 : _a.width, maxHeight: (_b = videoLayout === null || videoLayout === void 0 ? void 0 : videoLayout.container) === null || _b === void 0 ? void 0 : _b.height, margin: 'auto' })) }));
    };
    var wrapperStyle = styles(0, false)[2] || {
        height: '100%',
        position: 'relative',
        width: 'calc(var(--vw, 1vw) * 100)'
    };
    var containerStyle = {};
    if (presentationInLayout) {
        wrapperStyle = {
            height: '100%',
            position: 'relative',
            width: 'calc(var(--vw, 1vw) * 100)',
            display: 'flex',
            flexDirection: 'row-reverse'
        };
        containerStyle = __assign(__assign({}, styles(0, false)[2]), { position: 'relative', alignItems: 'flex-start', justifyContent: 'flex-start', alignContent: 'flex-start', maxHeight: (_c = videoLayout === null || videoLayout === void 0 ? void 0 : videoLayout.container) === null || _c === void 0 ? void 0 : _c.height, overflow: 'hidden' });
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { style: wrapperStyle, onMouseEnter: function () { return setIsHovering(true); }, onMouseLeave: function () { return setIsHovering(false); } },
            react_1.default.createElement("div", { style: containerStyle, className: classes.container }, remoteStreams.map(function (r, index) {
                var metadata = remoteStreamMetadata[r.id];
                // layout position calculation
                var i = index;
                if (metadata && Object.prototype.hasOwnProperty.call(metadata, 'index')) {
                    i = metadata.index;
                }
                var _a = styles(i, r.id === dominantTalker), containerStyle = _a[0], videoStyle = _a[1];
                return (react_1.default.createElement(RemoteVideo_1.default, { canPin: canPin, containerStyle: containerStyle, key: "remote-video-" + r.id, metadata: metadata, muted: muteRemotes, showMetadata: !isMinimized && showMetadata && isHovering, stream: r.stream, streamId: "" + r.id, videoStyle: videoStyle }));
            })),
            presentationInLayout && !isMinimized && react_1.default.createElement("div", { "data-testid": 'presentation-wrapper', style: { display: 'flex' } }, remotePresentation()),
            presentationInLayout && !isMinimized && (react_1.default.createElement(PresentationPopoutButton_1.default, { className: classes.popoutButton, isVisible: isHovering, intl: props.intl }))),
        remotePresentationStream && presentationLayout === __1.constants.SFU_PRES_LAYOUT_POPPEDOUT && (react_1.default.createElement(Popout_1.default, { windowName: presentationName })),
        presentationInLayout && Slider));
}
exports.default = CallLayout;
